import { render, staticRenderFns } from "./DetailFlow.vue?vue&type=template&id=572b2638&scoped=true&"
import script from "./DetailFlow.vue?vue&type=script&lang=js&"
export * from "./DetailFlow.vue?vue&type=script&lang=js&"
import style0 from "./DetailFlow.vue?vue&type=style&index=0&id=572b2638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572b2638",
  null
  
)

export default component.exports